module.exports = __webpack_public_path__ + "img/loader.d98bf658.svg";